export default [
  "Afghan",
  "Algerian",
  "Albanian",
  "Antiguan & Barbudan",
  "Australian",
  "Argentine",
  "Austrian",
  "Azerbaijani",
  "Bahraini",
  "Bangladeshi",
  "Belarusian",
  "Belgian",
  "Bolivian",
  "Brazilian",
  "Bruneian",
  "Bulgarian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Caymanian",
  "Chinese",
  "Colombian",
  "Costa Rican",
  "Croatian",
  "Chilean",
  "Cypriot",
  "Emirati",
  "Danish",
  "Egyptian",
  "Eritrean",
  "Timorese",
  "Equatoguinean",
  "Estonian",
  "Faroese",
  "Finnish",
  "French",
  "Fijian",
  "German",
  "Georgian",
  "Greek",
  "Guyanese",
  "Hong Konger",
  "Hungarian",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Japanese",
  "Jordanian",
  "Kazakhstani",
  "Kenyan",
  "Korean",
  "Kuwaiti",
  "Latvian",
  "Lebanese",
  "Libyan",
  "Lithuanian",
  "Malagasy",
  "Malaysian",
  "Maldivian",
  "Maltese",
  "Mauritian",
  "Mexican",
  "Mongolian",
  "Montenegrin",
  "Moroccan",
  "Burmese",
  "Nepali",
  "Dutch",
  "New Caledonian",
  "New Zealander",
  "Nigerian",
  "Niuean",
  "Norwegian",
  "Panamanian",
  "Pakistani",
  "Peruvian",
  "Filipino",
  "Polish",
  "Portuguese",
  "Romanian",
  "Russian",
  "Saudi",
  "Scottish",
  "Serbian",
  "Seychellois",
  "Singaporean",
  "Slovak",
  "Slovenian",
  "Solomon Islander",
  "South African",
  "Spanish",
  "Sri Lankan",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Thai",
  "Togolese",
  "Tongan",
  "Trinidadian & Tobagonian",
  "Tunisian",
  "Turkish",
  "Ugandan",
  "Ukrainian",
  "British",
  "American",
  "Ni-Vanuatu",
  "Venezuelan",
  "Vietnamese",
  "Zambian",
  "Zimbabwean"
];
